import * as utils from "../utils/utils.js";

export default function () {
  const widgetName = "fairSeoWidget";
  const widgetOpts = fairSeoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  const options = {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    moreButton: {
      visible: true,
      text: "Learn More",
    },
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
        $(".homepage .tier-3-container").addClass("no-seo-widget");
      } else {
        createCustomSeo(data.items);
      }
    },
  };

  return saffire.widgets.cardWidget($($widget), options);

  function createCustomSeo(widgetData) {
    const { Title, Description, URL } = widgetData[0];
    const attributeCheck = utils.isLocalUrl(URL) ? "" : 'target="_blank"';
    $widget.find(".card-widget-item").replaceWith(`
      <h1>${Title}</h1>
      <p>${Description}</p>
      <a href="${URL}" class="button" ${attributeCheck}>${options.moreButton.text}</a>
      `);
  }
}
